
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppProductEditRow from "./SaleEditRow.vue";
import Vue from "vue";
import { Contact } from "@/models/base";
import { SaleRow } from "@/models/base";
import { SaleEditState } from "../../utils/sale-edit/sale-edit-state";


export default Vue.extend({

	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		isNewRow():boolean {
			if (!this.state.selectedRow) {
				return false;
			}
			return this.state.sale.Rows.indexOf(this.state.selectedRow) == -1;
		},
		title():string {
			if (this.isNewRow) {
				return this.$ct("add-row").toString();
			}
			return this.$ct("edit-row").toString();
		},
		purchaseFromSupplier():Contact | null {
			if (this.state.sale.Type.ContactGroupID == 2) {
				return this.state.sale.Contact;
			}
			return null;
		}
	},
	methods: {
		close() {
			this.state.selectedRow = new SaleRow();
			this.state.productEditRowState.overrideMobileModalOpen = false;
		},
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppProductEditRow
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
